import React, {SVGProps} from "react";

/* The base of the approval icons */
export const IconThumbUp = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{margin: 0}}
            width={props.width ?? 16}
            height={props.height ?? 16}
            viewBox="0 0 15 15"
            fill="none"
            {...props}
        >
            <path
                stroke={props.color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.889}
                d="M5.333 14.333h-2A1.333 1.333 0 0 1 2 13V8.333A1.333 1.333 0 0 1 3.333 7h2M10 5.667V3a2 2 0 0 0-2-2L5.333 7v7.333h7.52a1.333 1.333 0 0 0 1.334-1.133l.92-6a1.333 1.333 0 0 0-1.334-1.533H10Z"
            />
        </svg>
    );
};
